import { CapoPlugin } from "/home/forge/dev-cloud.deal-buzzer.com/releases/20260908122233/client/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];